import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

function generateSessionId() {
  const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, (c) => {
    const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
try {
  if (!sessionStorage.getItem("story_session_id")) {
    const sessionId = generateSessionId();
    sessionStorage.setItem("story_session_id", sessionId);
  }
} catch (error) {
  console.error("Session storage unavailable:", error);
  // 使用更安全的命名避免全局污染
  if (!window.__storySessionId) {
    window.__storySessionId = generateSessionId();
  }
}

// ================= 新增心跳保活代码 =================
const initKeepAlive = () => {
    let isInitialRequestSent = false;
    
    const pingServer = () => {
      fetch('https://story-generator-backend-adhu.onrender.com/health')
        .catch(() => {});
    };
  
    if (!isInitialRequestSent) {
      // 立即发送首次请求
      pingServer();
      isInitialRequestSent = true;
      
      // 设置每5分钟定时器（300000毫秒）
      setInterval(pingServer, 300000);
    }
  };
  
  // 初始化Vue应用
  const app = createApp(App);
  
  // 启动心跳保活
  initKeepAlive();  // 新增这行
  
  // 挂载路由和store
  app.use(router).use(store).mount('#app');